import { usePermissionsContext } from '../../contexts/PermissionsContext';
import PermissaoTelaVazia from '../PermissaoTelaVazia';
import { IPermissionGuardProps, TPermissionId } from '../../types/permissions';

export default function PermissionGuard({ 
  permissionId, 
  children, 
  fallback = <PermissaoTelaVazia />
}: IPermissionGuardProps) {
  const { verificarPermissaoPorId } = usePermissionsContext();
  
  const hasPermission = verificarPermissaoPorId(permissionId);
  
  return hasPermission ? <>{children}</> : <>{fallback}</>;
}

export function usePermission(permissionId: TPermissionId): boolean {
  const { verificarPermissaoPorId } = usePermissionsContext();
  return verificarPermissaoPorId(permissionId);
} 